import React from 'react'
import SettlementTable from './SettlementTable'
import './index.less'

export type 购物车信息 = SwaggerDTO.购物车信息0 & { allSalePrice: number }

interface SettlementCardProps {
  data?: 购物车信息[]
}

export default function SettlementCard({ data }: SettlementCardProps) {
  return (
    <div className="settlement-card">
      <table className="settlement-tb">
        <colgroup>
          <col className="info-col" />
          <col className="price-col" />
          <col className="number-col" />
          <col className="amount-col" />
        </colgroup>
        <thead>
          <tr>
            <th className="settlement-t">商品信息</th>
            <th>单价</th>
            <th>数量</th>
            <th className="settlement-amount">金额</th>
          </tr>
        </thead>
        {data?.map(item => (
          <SettlementTable key={item.skuCode} data={item} />
        ))}
      </table>
    </div>
  )
}
